import { MutableRefObject } from 'react';

export const subHeadingFontSize = 17;
export const subHeadingLineHeight = 24;

export const captionFontSize = 13;
export const captionLineHeight = 18;

export type Settings = {
  placeholder?: string;
  readonlyPlaceholder?: string;
  suggestions?: { name: string; link: string }[];
  suggestionsDropdownElement?: MutableRefObject<HTMLDivElement | null>;
  canChangeBlockType?: boolean;
  canBold?: boolean;
  canItalic?: boolean;
  canUnderline?: boolean;
  canAddLists?: boolean;
  canChangeHistory?: boolean;
  canChangeFonts?: boolean;
  canAddLinks?: boolean;
  canFollowLinks?: boolean;
  canAlignText?: boolean;
  canHighlight?: boolean;
};
